import { Layout } from 'antd';
import logo from 'assets/img/logo.svg';
import styles from './AppHeader.module.less';
import VERSION from 'components/Version';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';

export default function AppHeader() {
	const { t } = useTranslation();
	const { logout } = useAuth0();

	return (
		<>
			<Layout.Header className={styles.header}>
				<div
					className={styles.headerLogo}
					onClick={() =>
						logout({
							returnTo: window.location.origin,
						})
					}
				>
					<img src={logo} alt="logo" />
				</div>
				<div className={styles.headerVersion}>
					<span>{`${t('common.version')} ${VERSION}`}</span>
				</div>
			</Layout.Header>
		</>
	);
}
